import React from "react";
import type { ReadingSection } from "../../tarot/reading/types";

export interface ReadingSectionsProps {
  sections: ReadingSection[];
}

const SectionValue: React.FC<{
  value: string | string[];
}> = ({
  value,
}) => {
  if (Array.isArray(value)) {
    return (
      <ul className="reading-section-list">
        {value.map(
          (
            item,
            index
          ) => (
            <li
              key={`${item}-${index}`}
            >
              {item}
            </li>
          )
        )}
      </ul>
    );
  }

  return (
    <div className="reading-section-value">
      {value}
    </div>
  );
};

export const ReadingSections:
  React.FC<
    ReadingSectionsProps
  > = ({
    sections,
  }) => {
    if (
      sections.length ===
      0
    ) {
      return (
        <div className="reading-sections__empty">
          Для этой позиции нет
          дополнительных секций
          интерпретации.
        </div>
      );
    }

    return (
      <div className="reading-sections">
        {sections.map(
          (section) => (
            <section
              className="reading-section"
              key={section.id}
            >
              <div className="reading-section-title">
                {section.title}
              </div>

              <SectionValue
                value={
                  section.value
                }
              />
            </section>
          )
        )}
      </div>
    );
  };

  